import React from 'react';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CustomMarker from '../map_interaction/CustomMarker';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import '../../styles/components/explore_page/SuggestionCard.css';

const SuggestionCard = ({ suggestion, markerColor }) => {
  const navigate = useNavigate();
  const isItinerarySuggestion = suggestion.itinerary_id && suggestion.itinerary_id !== "";
  const handleCardClick = () => {
    if (!isItinerarySuggestion) {
      navigate(`/destination/${suggestion.origin_id}`);
    }
  };
  const handleKeyDown = (e) => {
    if (!isItinerarySuggestion && e.key === 'Enter') {
      handleCardClick();
    }
  };
  const fadedColor = `${markerColor}20`;
  return (
    <Card
      className="suggestion-card"
      onClick={!isItinerarySuggestion ? handleCardClick : undefined}
      onKeyDown={!isItinerarySuggestion ? handleKeyDown : undefined}
      tabIndex={!isItinerarySuggestion ? 0 : -1}
      role={!isItinerarySuggestion ? "button" : "article"}
      aria-label={`Suggestion: ${suggestion.suggestion_name}`}
      style={{
        '--marker-color': markerColor,
        '--faded-color': fadedColor,
        cursor: !isItinerarySuggestion ? 'pointer' : 'default'
      }}
    >
      {suggestion.image_url && (
        <CardMedia
          component="img"
          alt={suggestion.suggestion_name}
          height="140"
          image={suggestion.image_url}
          className="suggestion-card-media"
        />
      )}
      <CardContent>
        <div className="suggestion-card-header">
          <div className="suggestion-card-marker-wrapper">
            <CustomMarker
              label={suggestion.suggestion_name}
              color={markerColor}
              type="suggestion"
              className="custom-marker-card"
            />
          </div>
          <Typography variant="h5" className="suggestion-card-title">
            {suggestion.suggestion_name}
          </Typography>
        </div>
        <Typography variant="body1" className="suggestion-card-summary">
          {suggestion.suggestion_summary}
        </Typography>
        {!isItinerarySuggestion && (
          <div className="click-to-explore-container">
            <Typography variant="caption" className="click-to-explore">
              Click to explore <ArrowForwardIcon fontSize="small" />
            </Typography>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SuggestionCard;
